import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { authSelector } from "../components/Auth/AuthSlice";
import AbacNavLoaderHost from "../components/User/Abac/AbacNavLoaderHost";
import { hasNoAllowedAbacPages } from "../components/User/Abac/abacRouteMap";
import { useAbacSessionPending } from "../hooks/useAbacAccess";
import { useFullscreen } from "../contexts/FullscreenContext";
import AppShellSkeleton from "./AppShellSkeleton";
import { LayoutChromeProvider } from "./LayoutChromeContext";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";

const MainLayout = () => {
  const location = useLocation();
  const { user, abacPermissions } = useSelector(authSelector);
  const abacPending = useAbacSessionPending();
  const { isFullscreen = false, setIsFullscreen } = useFullscreen();
  const hideChromeForAbac = hasNoAllowedAbacPages(
    abacPermissions,
    user,
    globalThis.profileData
  );
  const hideAppChrome = hideChromeForAbac || isFullscreen;

  useEffect(() => {
    setIsFullscreen(false);
  }, [location.pathname, setIsFullscreen]);

  if (abacPending) {
    return <AppShellSkeleton />;
  }

  if (hideChromeForAbac) {
    return <Outlet />;
  }

  return (
    <LayoutChromeProvider>
      <div
        className={`d-flex layoutContainer${
          isFullscreen ? " fullscreen-mode" : ""
        }`}
      >
        {!hideAppChrome && <Sidebar />}
        <div className="flex-grow-1 main">
          {!hideAppChrome && <Navbar />}
          <AbacNavLoaderHost />
          <Outlet />
        </div>
      </div>
    </LayoutChromeProvider>
  );
};

export default MainLayout;
